import { render, staticRenderFns } from "./PlaylistDefault.vue?vue&type=template&id=3602b5b3&scoped=true"
import script from "./PlaylistDefault.vue?vue&type=script&lang=js"
export * from "./PlaylistDefault.vue?vue&type=script&lang=js"
import style0 from "./PlaylistDefault.vue?vue&type=style&index=0&id=3602b5b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3602b5b3",
  null
  
)

export default component.exports